<template>
    <div class="account">
        <el-breadcrumb separator-class="el-icon-arrow-right" v-if="postList.headerTitle">
            <el-breadcrumb-item>绩效单元</el-breadcrumb-item>
        </el-breadcrumb>
        <el-row class="main_header">
            <div class="main_header_item">
                <el-input v-model="queryParams.id" placeholder="请输入ID" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.code" placeholder="请输入编码" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>

            <div class="main_header_item">
                <el-input v-model="queryParams.name" placeholder="请输入名称" clearable @keyup.enter.native="getList(1)"></el-input>
            </div>
            <div class="main_header_item" v-if="postList.parent_code">
                <el-input
                    v-model="queryParams.parent_code"
                    placeholder="请输入父级编码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item" v-if="postList.parent_code">
                <el-input
                    v-model="queryParams.parent_name"
                    placeholder="请输入父级名称"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.period_code"
                    placeholder="请输入期间编码"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="person_code"
                    model_name="请选择人员"
                    :model_value_default="queryParams['person_code']"
                    select_value="code"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="person_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdownMul
                    model_key="visible_person_codes"
                    model_name="请选择可见人"
                    :model_value_default="queryParams['visible_person_codes']"
                    select_value="code"
                    request_uri="dropdownPerson"
                    @onDropChange="onDropChange"
                    ref="visible_person_codes_ref"
                ></vDropdownMul>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="business_unit_rid"
                    model_name="请选择业务单元"
                    :model_value_default="queryParams['business_unit_rid']"
                    request_uri="dropdownBusinessUnits"
                    @onDropChange="onDropChange"
                    ref="business_unit_rid_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="lock_sign"
                    model_name="请选择锁定标记"
                    select_value="value"
                    :model_value_default="queryParams['lock_sign']"
                    request_uri="dropdownPerformanceLockSign"
                    @onDropChange="onDropChange"
                    ref="lock_sign_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="base_basis_code"
                    model_name="请选择基础基数依据"
                    select_value="value"
                    :model_value_default="queryParams['base_basis_code']"
                    request_uri="dropdownBaseBasis"
                    @onDropChange="onDropChange"
                    ref="base_basis_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="base_type_code"
                    model_name="请选择基数类型"
                    select_value="value"
                    :model_value_default="queryParams['base_type_code']"
                    request_uri="dropdownBaseType"
                    @onDropChange="onDropChange"
                    ref="base_type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <vDropdownMul
                    model_key="base_factor_sign"
                    model_name="请选择基数因子标识"
                    select_value="value"
                    request_uri="dropdownPerformanceBaseFactorSign"
                    :model_value_default="queryParams['base_factor_sign']"
                    @onDropChange="onDropChange"
                    ref="base_factor_sign_ref"
                ></vDropdownMul>
            </div>
            <div class="main_header_item">
                <vDropdown
                    model_key="progress_type_code"
                    model_name="请选择进度标记"
                    select_value="value"
                    :model_value_default="queryParams['progress_type_code']"
                    request_uri="dropdownParameterProgress"
                    @onDropChange="onDropChange"
                    ref="progress_type_code_ref"
                ></vDropdown>
            </div>
            <div class="main_header_item">
                <el-input
                    v-model="queryParams.depth_increment"
                    placeholder="请输入深度调增"
                    clearable
                    @keyup.enter.native="getList(1)"
                ></el-input>
            </div>
        </el-row>
        <div class="main_list">
            <div class="flex">
                <el-button size="small" plain @click="insert" icon="el-icon-plus" :loading="btnLoading">新增</el-button>

                <el-button size="small" plain @click="recalculate(1)" :loading="btnLoading">重算绩效</el-button>
                <el-button size="small" plain @click="recalculate(2)" :loading="btnLoading">全局绩效重算</el-button>
                <!-- <el-button size="small" plain @click="recalculate(3)" :loading="btnLoading">重算绩效产品行</el-button> -->
                <el-button size="small" plain @click="flushRelease()" :loading="btnLoading">刷新释放率</el-button>
                <el-button size="small" plain @click="show_help()" icon="el-icon-question">帮助信息</el-button>

                <div class="main_header_btns">
                    <el-button type="primary" size="small" @click="getList(1)">搜索</el-button>
                    <el-button size="small" type="primary" plain @click="reset">重置</el-button>
                    <el-button size="small" plain icon="el-icon-bottom" @click="getList(2)" :loading="down_loading">下载</el-button>
                    <crm-upload obj="performance_unit" :queryParams="queryParams"></crm-upload>
                    <draggableList :draggable="draggable" @isErrShow="onSetFieldDone"></draggableList>
                </div>
            </div>

            <div v-show="is_show_help">
                <div class="flex">
                    <span style="color: red; font-size: 13px">绩效重算：【汇总绩效产品行到绩效产品】+【汇总绩效产品到绩效单元】 </span>
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >全局绩效重算：【重算相关数据到绩效产品行】+【汇总绩效产品行到绩效产品】+【汇总绩效产品到绩效单元】
                    </span>
                </div>
                <!-- <div class="flex">
                    <span style="color: red; font-size: 13px">重算绩效产品行：【重算相关数据到绩效产品行】 </span>
                </div> -->
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >计算过程依赖应收、清账、流向、流向扩展、流向状态等数据；计算过程中勿对依赖数据进行调整，否则计算结果可能产生偏差</span
                    >
                </div>
                <div class="flex">
                    <span style="color: red; font-size: 13px"
                        >刷新释放率：根据最新的清账、应收情况，刷新近10年的与释放率相关的字段。需要在参数中配置"绩效释放截止日"</span
                    >
                </div>
                <div class="flex" v-for="(item, index) in taskQueueMessage" :key="index">
                    <span style="color: red; font-size: 13px">
                        {{ item }}
                    </span>
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                ref="tableDataRef"
                :max-height="this.$tableHeight"
                class="performance_unit"
                @header-dragend="changeColWidth"
                v-loading="loading"
                element-loading-text="拼命加载中"
                element-loading-spinner="el-icon-loading"
                element-loading-background="rgba(255, 255, 255, 0.8)"
                style="width: 100%"
            >
                <template v-for="(item, index) in colData">
                    <el-table-column
                        :key="index"
                        :prop="item.prop"
                        :label="item.title"
                        :min-width="item.width"
                        :sortable="item.sort"
                        align="left"
                        show-overflow-tooltip
                        v-if="colData[index].is_show"
                    >
                        <template slot-scope="scope">
                            <div v-if="in_array(item.prop, ['name'])">
                                <el-link type="primary" @click="toDetail(scope.row, item.prop)" style="font-size: 11px"
                                    >{{ scope.row[item.prop] }}
                                </el-link>
                            </div>
                            <div v-else>
                                <span> {{ scope.row[item.prop] }} </span>
                            </div>
                        </template>
                    </el-table-column>
                </template>
                <el-table-column label="操作" width="80" fixed="right">
                    <template slot-scope="scope">
                        <el-tooltip class="item" effect="dark" content="复制" placement="top-start">
                            <i class="el-icon-menu" @click="copy(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="编辑" placement="top-start">
                            <i class="el-icon-s-claim" @click="update(scope.row.id)"></i>
                        </el-tooltip>
                        <el-tooltip class="item" effect="dark" content="删除" placement="top-start">
                            <i class="el-icon-delete-solid" @click="del(scope.row)"></i>
                        </el-tooltip>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination">
                <el-pagination
                    background
                    layout="total,prev, pager, next, sizes, jumper"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-sizes="[10, 25, 50, 75, 100]"
                    :current-page="queryParams.page"
                    :page-size="queryParams.row"
                    :total="total"
                ></el-pagination>
            </div>
        </div>
    </div>
</template>
<script>
import { onDelete, onReSize, onSearch, in_array } from '@/js/common.js';
import draggableList from '@/components/common/Drawer.vue';
import vSearchSelect from '@/components/common/dropdown/search.vue';
import crmUpload from '@/components/common/Upload.vue';
import vDropdownMul from '@/components/common/dropdown/dropdownMul.vue';

export default {
    inject: ['reload'],
    //注册draggable组件
    components: {
        draggableList,
        vSearchSelect,
        vDropdownMul,
        crmUpload
    },
    name: 'performanceUnitComponent',
    data() {
        return {
            is_show_help: false,
            draggable: {
                data_name: 'performance_unit'
            },
            down_loading: false,
            btnLoading: false,
            loading: true,
            tableData: [],
            colData: [],
            total: 0,
            // sort: '', //排序参数
            // data_name: '', //排序参数
            queryParams: {},
            taskQueueMessage: []
        };
    },
    props: {
        postList: {
            type: Object
        }
    },
    beforeMount() {
        this.recoveryQueryParams('page');
        this.initTaskQueueMessage();
    },
    mounted() {
        this.$nextTick(() => {
            this.selectedColData(); //筛选列
            this.recoveryQueryParams();
            if (this.postList.params) {
                //如果详情列表需要搜索参数 重置按钮放出来 注意 传来的id不可被重置掉
                this.queryParams.row = 10;
                this.queryParams.parent_code = this.postList.params.parent_code;
                this.getList(0);
            } else {
                this.getList(0); //获取列表
            }
        });
    },
    methods: {
        in_array,
        show_help() {
            this.is_show_help = this.is_show_help == false ? true : false;
        },
        initTaskQueueMessage() {
            // 2个走任务队列，2个不走任务队列，只是记录了一个任务日志
            this.$api['taskQueueMessage']({
                code: ['recalculate_performance_local', 'recalculate_performance', 'flush_performance_released_rate']
            })
                .then((res) => {
                    if (res.code == 0) {
                        this.taskQueueMessage = res.data;
                    }
                })
                .catch((error) => {
                    this.taskQueueMessage = [];
                });
        },
        //跳转详情
        toDetail(row, prop) {
            if (in_array(prop, ['name']) && row.id) {
                this.$router.push({
                    path: '/performanceUnitDetail',
                    query: {
                        id: row.id
                    }
                });
            }
        },
        initQueryParams() {
            this.queryParams = {
                page: 1,
                row: 25,
                is_export: 0,
                parent_code:
                    this.postList && this.postList.params && this.postList && this.postList.params.parent_code
                        ? this.postList.params.parent_code
                        : ''
            };

            this.saveQueryParams();
        },
        onDropChange(key, value) {
            this.queryParams[key] = value;
        },
        saveQueryParams() {
            if (!this.postList.params) {
                localStorage.setItem('performance_unit_params', JSON.stringify(this.queryParams));
            }
        },
        // 分页参数需要在beforeMount初始化，先兼容下
        recoveryQueryParams(type = 'common') {
            //详情内调用不用本地存储的params
            if (!this.postList.params) {
                //列表页面调用 优先取本地存储
                const queryParams = JSON.parse(localStorage.getItem('performance_unit_params'));
                if (queryParams) {
                    if (type == 'common') {
                        this.queryParams = queryParams;
                    } else {
                        this.queryParams.page = queryParams.page || 1;
                        this.queryParams.row = queryParams.row || 25;
                    }
                } else {
                    this.initQueryParams();
                }
            }
        },
        //子组件更新完毕
        onSetFieldDone(data) {
            //刷新下页面
            this.reload();
        },
        //列宽改变事件
        changeColWidth(nw, ow, col, evt) {
            onReSize('performance_unit', this);
        },
        //筛选列
        selectedColData() {
            this.colData = JSON.parse(localStorage.getItem('dataList')).performance_unit;
        },
        // 获取列表 0-非搜索 1-搜索 2-下载
        getList(search_type = 0) {
            onSearch(search_type, this, 'performanceUnitLists');
        },
        //新增
        insert() {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'insert'
                }
            });
        },
        //删除
        del(row) {
            onDelete(row.id, this, 'performanceUnitDelete', row.name);
        },
        //编辑
        update(id) {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'update',
                    id: id
                }
            });
        },
        //复制
        copy(id) {
            this.$router.push({
                path: 'performanceUnitEdit',
                query: {
                    type: 'copy',
                    id: id
                }
            });
        },
        currentChange(page) {
            this.queryParams.page = page;
            this.saveQueryParams();
            this.getList(0);
        },
        sizeChange(row) {
            this.queryParams.row = row;
            this.saveQueryParams();
            this.getList(0);
        },
        reset() {
            this.initQueryParams();
            this.$refs.person_code_ref.reset();
            this.$refs.business_unit_rid_ref.reset();
            this.$refs.lock_sign_ref.reset();
            this.$refs.base_factor_sign_ref.reset();
            this.$refs.progress_type_code_ref.reset();
            this.$refs.base_basis_code_ref.reset();
            this.$refs.base_type_code_ref.reset();
            this.$refs.visible_person_codes_ref.reset();
            this.getList();
        },
        // 重算绩效
        recalculate(type) {
            this.$confirm('您确定要进行重算吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['performanceUnitRecalculate']({ type: type })
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: res.data,
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        },
        // 刷新释放率
        flushRelease() {
            this.$confirm('您确定要进行刷新吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
                closeOnPressEscape: false,
                closeOnClickModal: false
            })
                .then(() => {
                    this.btnLoading = true;
                    this.$api['performanceUnitFlushRelease']({})
                        .then((res) => {
                            if (res.code == 0) {
                                this.$message({
                                    message: '操作成功',
                                    type: 'success'
                                });
                                this.reload();
                            }
                            this.btnLoading = false;
                        })
                        .catch((error) => {
                            this.btnLoading = false;
                        });
                })
                .catch(() => {});
        }
    }
};
</script>
<style lang="scss" scoped>
/deep/ .el-table__empty-block {
    width: 100% !important;
    min-width: 100% !important;
    max-width: 100% !important;
    padding-right: 100% !important;
}
</style>